import React, {} from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import * as PropTypes from 'prop-types';
import {Icon, Affix, Row, Typography} from 'antd';
import ViaDropMenu from '../menu/ViaDropMenu';
import bynxMenuStructure from '../../sections/secured/bynx/bynxMenuStructure';
import { requestSignOut } from '../../state/ui/application/sessionUiActions';
import { selectSessionUser } from '../../state/ui/application/sessionUiReducer';
import { ViaLogo, LogoLocations } from '../logo/ViaLogo';

const { Title } = Typography;

/**
 * The standard version of the menu.
 * @param {object} props The react props.
 * @param {string} props.username The sign in user.
 * @param {number} props.creditBalance The credit balance of the user group.
 * @param {func} props.onSignOut A function that is executed when the user attempts to signout.
 */
function StandardMenu({ username, onSignOut, sessionUser }) {
  return (
    <>
      <ViaDropMenu
        mode="horizontal"
        menuStructure={bynxMenuStructure}
        subMenuTitle={(
          <Row className="via-header-menu-button" style={{ marginTop: '0.2em' }} type="flex" align="middle">
            <Icon type="setting" />
            <FormattedMessage id="menu" />
          </Row>
        )}
        sessionUser={sessionUser}
      />
      <Row className="via-header-menu-button" style={{ margin: '13px' }} type="flex" align="middle">
        <Icon type="user" />
        &nbsp;
        {username}
      </Row>
      <Row className="via-header-menu-button" onClick={() => onSignOut()} style={{ margin: '13px', cursor: 'pointer' }} type="flex" align="middle">
        <Icon type="poweroff" />
        &nbsp;
        <FormattedMessage id="signOut" />
      </Row>

    </>
  );
}

StandardMenu.propTypes = {
  username: PropTypes.string.isRequired,
  onSignOut: PropTypes.func.isRequired,
  sessionUser: PropTypes.object.isRequired,
};


/**
 * The appliccation header for authenticated users.
 * @param {object} props The react props.
 * @param {object} props.sessionUser The current authenticated user.
 * @param {func} props.onSignOut A function that is executed when the user attempts to signout.
 */
export default function ViaHeaderBynx() {
  // Redux State
  const sessionUser = useSelector(selectSessionUser);
  const dispatch = useDispatch();
  const onSignOut = () => dispatch(requestSignOut());

  const username = sessionUser ? sessionUser.displayName : '';
  const creditBalance = sessionUser ? sessionUser.credits : 0;

  return (// Ant messages have z-index of 1010 so dont make this any higher than that!
    <header style={{ zIndex: '999' }}>
      <Affix offsetTop={0} style={{ height: '50px' }}>
        <div className="via-header-layout via-header-layout--bynx">
          <div className="via-header-view">
            <ViaLogo logoSrc={LogoLocations.NORMAL_BLACK_CIRCLE_BLUE_M} className="via-header-logo" />
            <Title level={4} style={{ marginTop: '0.8em' }}>Admin Console</Title>
            <div className="via-header-links">
              <StandardMenu creditBalance={creditBalance} username={username} onSignOut={onSignOut} sessionUser={sessionUser} />
            </div>
          </div>
        </div>
      </Affix>
    </header>
  );
}
